const profile = new Map<string, string>();
document.querySelectorAll<HTMLMetaElement & HTMLLinkElement>('head > [itemprop]').forEach((el) => {
    const prop = el.getAttribute('itemprop');
    if (prop) {
        profile.set(prop, el.href || el.content);
    }
});
export { profile };
